import { render, staticRenderFns } from "./addPlanOfProject.vue?vue&type=template&id=82527cfc"
import script from "./addPlanOfProject.vue?vue&type=script&lang=js"
export * from "./addPlanOfProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports